// Centralized configuration
// All environment variables should be accessed through this config

function getConfigValue(key: string, defaultValue = ''): string {
  return import.meta.env[key] || defaultValue;
}

export const config = {
  // OIDC Configuration
  oidc: {
    get authority(): string {
      return getConfigValue(
        'VITE_OIDC_AUTHORITY',
        'https://auth.fancycloud.ca/oauth2/openid/fancycloud-portal-public',
      );
    },
    get clientId(): string {
      return getConfigValue('VITE_OIDC_CLIENT_ID', 'fancycloud-portal-public');
    },
    get redirectUri(): string {
      return (
        getConfigValue('VITE_OIDC_REDIRECT_URI') ||
        `${window.location.origin}/callback`
      );
    },
    get loginUrl(): string {
      return getConfigValue('VITE_OIDC_LOGIN_URL');
    },
  },
  
  // API Configuration
  api: {
    get baseUrl(): string {
      return getConfigValue('VITE_API_URL');
    },
    get useMock(): boolean {
      const apiUrl = getConfigValue('VITE_API_URL');
      const useMock = getConfigValue('VITE_USE_MOCK_API');
      return useMock === 'true' || !apiUrl;
    },
  },
  
  // External URLs
  urls: {
    get dashboard(): string {
      return getConfigValue('VITE_DASHBOARD_URL');
    },
  },
  registration: {
    get baseUrl(): string {
      return (
        getConfigValue('VITE_REGISTRATION_SERVICE_URL') ||
        'https://registration.fancycloud.ca'
      );
    },
  },
};

// Log config in development for debugging
if (import.meta.env.DEV) {
  console.log('FancyCloud Config:', {
    oidcAuthority: config.oidc.authority ? '(set)' : '(not set)',
    oidcClientId: config.oidc.clientId ? '(set)' : '(not set)',
    apiBaseUrl: config.api.baseUrl || '(not set - using mock)',
    useMockApi: config.api.useMock,
    dashboardUrl: config.urls.dashboard || '(not set)',
    registrationServiceUrl: config.registration.baseUrl || '(not set)',
  });
}
